
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"fill":"#2c2c30","stroke":"#707070","d":"M0 0h24v24H0z","transform":"translate(-2081 -1782)"}})])]),_c('g',{attrs:{"fill":"#2c2c30","clip-path":"url(#a)","transform":"translate(2081 1782)"}},[_c('path',{attrs:{"d":"M-2076.359-1763.965h14.717a1.606 1.606 0 001.074-.332 1.107 1.107 0 00.391-.889 2.035 2.035 0 00-.557-1.353q-.557-.64-1.172-1.245a1.971 1.971 0 01-.474-.781 5.7 5.7 0 01-.254-1.045q-.083-.557-.122-1.074-.02-.449-.049-.884t-.078-.845a3.755 3.755 0 01-.747.234 4 4 0 01-.8.078 4.312 4.312 0 01-2.237-.604 4.578 4.578 0 01-1.625-1.623 4.312 4.312 0 01-.605-2.241 4.3 4.3 0 01.293-1.592 4.6 4.6 0 01.811-1.338 2.573 2.573 0 00-1.2-.283 2.526 2.526 0 00-1.733.625 3.259 3.259 0 00-.984 1.529 4.312 4.312 0 00-1.963 1.363 6.149 6.149 0 00-1.118 2.29 13.327 13.327 0 00-.415 3.086q-.059.576-.142 1.172a5.941 5.941 0 01-.259 1.108 2.115 2.115 0 01-.488.825q-.615.606-1.172 1.246a2.035 2.035 0 00-.557 1.353 1.107 1.107 0 00.391.889 1.606 1.606 0 001.074.331zm7.363 3.75a2.979 2.979 0 001.436-.342 2.8 2.8 0 001.016-.908 2.569 2.569 0 00.439-1.221h-5.791a2.542 2.542 0 00.444 1.221 2.841 2.841 0 001.021.908 2.979 2.979 0 001.435.342zm4.58-13.164a3.048 3.048 0 001.6-.435 3.338 3.338 0 001.159-1.157 3.048 3.048 0 00.435-1.6 3.048 3.048 0 00-.435-1.6 3.338 3.338 0 00-1.157-1.157 3.168 3.168 0 00-3.2 0 3.338 3.338 0 00-1.157 1.157 3.048 3.048 0 00-.435 1.6 3.048 3.048 0 00.435 1.6 3.338 3.338 0 001.154 1.157 3.048 3.048 0 001.602.435z"}})])])
          )
        }
      }
    